export default __webpack_public_path__ + "static/guest_title_background-c6f573c9f46d6f322ed885f53e20dbc2.png";